<template>
  <span>
    <!-- Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.custom_fields.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
    <!-- Create Edit-->
    <v-dialog v-model="dialogFieldEditable" max-width="550px" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{this.origin_field_name === 'connection_id' ? 'Outros Campos' : 'Campos Personalizados'}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding: 5px">
          <v-layout wrap justify-center align-center>
            <v-flex xs12 class="text-xs-right">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" @click="createField" v-on="on">
                    Adicionar Campo
                    <v-icon dark>{{translate('system.button.add.icon')}}</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-tile v-for="(option, index) in fieldsList" :key="index" @click="createItem(option)">
                    <v-icon>{{getFieldIcon(option['type'])}}</v-icon><span style="padding-left: 10px;">{{option['title']}}</span>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
            <v-layout row class="pa-2">
              <v-flex xs12>
                <v-card>
                  <v-list dense subheader>
                    <v-layout>
                      <v-flex xs10>
                        <v-subheader>Descrição</v-subheader>
                      </v-flex>
                      <v-flex xs2>
                        <v-subheader>Ações</v-subheader>
                      </v-flex>
                    </v-layout>                    
                    <v-divider></v-divider>
                    <!-- // Adicionar campo -->
                    <v-list-tile v-if="showAddField">
                      <v-icon>{{getFieldIcon(editedItem['type'])}}</v-icon>
                      <v-text-field id="addCustomField" v-model="editedItem['title']" @keyup.enter="doneCustomField" @keyup.esc="closeCustomField" ref="addCustomField"  placeholder="Digite o nome do Campo" maxlength="190" style="padding-left: 10px;"></v-text-field>
                      <!-- <v-spacer></v-spacer> -->
                      <v-flex shrink>
                          <v-btn @click="doneCustomField" :loading="loadingAddField" fab small icon class="mx-0">
                            <v-icon medium>done</v-icon>
                          </v-btn>
                          <v-btn @click="closeCustomField" fab small icon class="mx-0">
                            <v-icon medium>close</v-icon>
                          </v-btn>
                      </v-flex>
                    </v-list-tile>
                    <v-divider></v-divider>
                      <div v-for="(field, index) in customFields" :key="index" :class="field['expanded'] ? 'background-expanded' : ''">
                        <!-- // Mostra o campo para editar/criar o registro -->
                        <v-list-tile v-if="fieldEditing[`cf_${field['id']}`]" :key="index">
                          <v-icon style="margin-right: 10px">{{getFieldIcon(editedItem['type'])}}</v-icon>
                          <v-text-field id="editCustomField" v-model="editedItem['title']" @keyup.enter="doneCustomField" @keyup.esc="closeCustomField" ref="addCustomField"  placeholder="Digite o nome do Campo" maxlength="190" style="padding-left: 10px;"></v-text-field>
                          <v-flex shrink>
                            <v-btn @click="doneCustomField" :loading="loadingAddField" fab small icon class="mx-0">
                              <v-icon medium>done</v-icon>
                            </v-btn>
                            <v-btn @click="closeCustomField" fab small icon class="mx-0">
                              <v-icon medium>close</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-list-tile>
                        <!-- // Mostra o campo de visualizar o registro -->
                        <v-list-tile v-else :key="index">
                          <v-icon @click="['select', 'multiselect'].includes(field['type']) ? openCustomFieldOption(field) : ''"  style="margin-right: 10px">{{getFieldIcon(field['type'])}}</v-icon>
                          <v-hover :disabled="$vuetify.breakpoint.smAndDown" :key="index">
                            <v-flex grow slot-scope="{ hover }" @click="editItem(field)">
                              <v-tooltip top>
                                  <span slot="activator" :class="hover ? 'show-edit-border' : 'show-edit'">{{field['title']}}</span>
                                  <span>Editar</span>
                              </v-tooltip>
                            </v-flex>
                          </v-hover>
                          <v-flex shrink>
                            <v-tooltip top v-if="['select', 'multiselect'].includes(field['type'])">
                              <v-btn icon class="mx-0" slot="activator" @click="openCustomFieldOption(field)">
                                <v-icon :color="field['expanded'] ? 'black' : 'primary'">{{field['expanded'] ? 'close' : 'add'}}</v-icon>
                              </v-btn>
                              <span>Incluir opções</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <v-btn icon class="mx-0" slot="activator" @click="dialogDelete(field)">
                                <v-icon color="pink">delete</v-icon>
                              </v-btn>
                              <span>Excluir</span>
                            </v-tooltip>
                          </v-flex>
                        </v-list-tile>
                      <v-expand-transition>
                        <!-- // Possui o expanded_transaction para deixar o epxanded carregar o custo-field-option primeiro e depoi o expanded_transaction habilite para fazer a animação  -->
                        <div v-show="field['expanded_transaction']">
                          <p-custom-field-option v-if="field['expanded']" :key="'c'+index" :field_id="field['id']" :originView="originView"/>
                        </div>
                      </v-expand-transition>
                      <v-divider :key="'d'+index"></v-divider>
                    </div>
                    <v-list-tile three-line v-if="customFields.length === 0">
                      Adicione uma opção
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" @click.native="dialogFieldEditable = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<style scoped>
  .background-expanded {
    background-color:rgb(223, 223, 223)
  }
  
  .show-edit-border {
    display: inline-block;
    padding: 7px;
    cursor: pointer;
    width: 100%;
    border-radius: 5px;
    border: 1px solid;
  }
  .show-edit {
    /* min-height: 50px; */
    padding: 5px;
    border: 1px solid;
    border-color: rgba(255, 255, 255, 0);
    /* padding-left: 5px; */
  }
</style>
<script>
  /* eslint-disable */
  /* eslint-disable eqeqeq */
  import PConfirm from './PConfirm'
  import PCustomFieldOption from './PCustomFieldOption'

  export default {
    name: 'PCustomFieldEditable',
    components: {PConfirm, PCustomFieldOption},
    props: {
      // origin_field_name task_id ou tasktemplate_id
      origin_field_name: {
        type: String,
        default: 'tasktemplate_id'
      },
      task_id: {
        type: Number,
        default: 0
      },
      tasktemplate_id: {
        type: Number,
        default: 0
      },
      // view usado para saber se está na inclusão ou edição da tarefa ou tarefa modelo, para fazer os devidos tratamentos
      originView: {
        type: Number,
        default: 0
      }
    },
    data: () => ({
      view: 1,
      // idCount criado para definir o id negativos no momento de inclusão, pois assim não corre o risco de sair algum repetido
      idCount: 0,
      dialogFieldEditable: false,
      dialogConfirm: false,
      loadingAddField: false,
      showAddField: false,
      fieldsList: [],
      entity: 'custom_fields',
      // fieldEditing identifica e gerencia qual o campo que está em edição
      fieldEditing: {},
      defaultFieldEditing: {},
      // editing usado para saber quando o campos esta editando
      editedItem: {},
      // Armazena o id do ultimo item de opções que foi inserido para poder fechar justamente ele depois
      lastFieldOptionOpenId: 0,
      defaultItem: {}
    }),
    created () {
      this.fieldsList = this.translate('value.field_options')
      // tira os arquivos quando é cliente
      if (this.origin_field_name === 'connection_id') this.fieldsList = this.fieldsList.filter((field) => field['type'] != 'files' )
      // Insere a origin_field_name para saber onde usar, na edição ou inclusão
      this.editedItem = {title: '', id_text: '', type: 'string', company_id: this.$auth.user().company_id, task_id: null, tasktemplate_id: null, origin_field_name: this.origin_field_name, value: null, value_item: null}
      this.defaultItem = {title: '', id_text: '', type: 'string', company_id: this.$auth.user().company_id, task_id: null, tasktemplate_id: null, origin_field_name: this.origin_field_name, value: null, value_item: null}
    },
    methods: {
      openCustomFieldOption (field) {
        this.closeLastOption()
        // Ao receber o default fechar o campo que estão aberto
        Object.assign(this.fieldEditing, this.defaultFieldEditing)
        // Coloca o id do field no lastFieldOptionOpenId para poder saber qual está aberto e já fechar quando for feito alguma outra ação
        this.lastFieldOptionOpenId = field['id']
        // Verifica se já existe o expanded pois se existir reverte ele, pois se estiver aberto ira fechar e se tiver fechado ira abrir, ecaso ele não exista adiciona o true
        let value = field.hasOwnProperty('expanded') ? !field['expanded'] : true
        // Dependendo do valeu colocar define qual dar variaveir ira pro setTImeOut para fazer o transaction funcionar corretamente
        if (value) {
          this.$set(field, 'expanded', value)
          setTimeout(() => { this.$set(field, 'expanded_transaction', value) }, 100)
        } else {
          this.$set(field, 'expanded_transaction', value)
          setTimeout(() => { this.$set(field, 'expanded', value) }, 100)
        }
      },
      editItem (field) {
        this.view = 3
        // caso o add esteja ativo fecha ele
        this.showAddField = false
        this.closeLastOption()
        // Ao receber o default fechar todos os campos que podem estar abertos
        Object.assign(this.fieldEditing, this.defaultFieldEditing)
        this.$set(this.fieldEditing, `cf_${field['id']}`, true)
        // set false no defult para que fechar todos que foram abertos
        this.$set(this.defaultFieldEditing, `cf_${field['id']}`, false)
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(field)))
        // Já insere false, pois nos caso do select ou multiselect o closeLastOption fecha o expanded depois, e o editedItem deve receber o field já com o expanded false
        this.editedItem['expanded_transaction'] = false
        this.editedItem['expanded'] = false
        // Já foca no campo de edição
        setTimeout(() => {
          document.getElementById('editCustomField').click()
        }, 100)
      },
      createItem (option) {
        // caso a adição já esteja aberta, então adiciona o item
        if (this.showAddField) {
          this.doneCustomField()
        }
        this.view = 2
        this.showAddField = true
        this.closeLastOption()
        // Ao receber o default fechar todos os campos que podem estar abertos
        Object.assign(this.fieldEditing, this.defaultFieldEditing)
        // joga os valores defalt dentro do editedItem
        Object.assign(this.editedItem, this.defaultItem)
        // Pega o tipo de acordo com o que o usuário selecionou (number, string, select ...)
        this.editedItem['type'] = option['type']
        // Já foca no campo de inclusão
        setTimeout(() => {
          document.getElementById('addCustomField').click()
        }, 100)
      },
      doneCustomField () {
        if (this.editedItem['title'] === '') {
          this.$store.commit('snackbar/change_values', {
            text: 'Favor preencher o campo!', color: 'warning', dialog: true
          })
          document.getElementById('addCustomOption').click()
          return 0
        }
        // origin_field_name pode ser task_id ou tasktemplate_id
        this.editedItem[this.origin_field_name] = this[this.origin_field_name]
        if (this.view === 2) {
          // se a tarefa ou tarefa modelo for inclusão então não usa o banco, pois isso é feito no fim do processo
          if (this.originView === 2) {
            // idCount Insere um id negativo para não ter risco de ficar ids repetidos
            this.idCount--
            this.editedItem['id'] = this.idCount
            this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/add_value`, this.editedItem)
            // verifica se é seleção e se for expande para o usuário inserir as opções
            if (['select', 'multiselect'].includes(this.editedItem['type'])) {
              this.$set(this.editedItem, 'expanded', true)
              this.$set(this.editedItem, 'expanded_transaction', true)
              this.lastFieldOptionOpenId = this.editedItem['id']
            }
            this.closeCustomField()
          } else {
            this.loadingAddField = true
            this.$http.post('api/' + this.entity, this.editedItem).then(
              (res) => {
                if (['select', 'multiselect'].includes(this.editedItem['type'])) {
                  this.$set(res.body, 'expanded', true)
                  this.$set(res.body, 'expanded_transaction', true)
                  this.lastFieldOptionOpenId = res.body['id']
                }
                this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/add_value`, res.body)
                // ---- Inicio Socket----
                // adiciona na tarefa e na tarefa modelo
                this.$socket.emit('generalEvent', {
                  data: res.body,
                  responseEvent: 'addSocketCustomField',
                  room: `tasktemplates_cf_${this.tasktemplate_id}`
                })
                // ---- Fim Socket----
                this.closeCustomField()
                this.$store.commit('snackbar/change_values', {
                  text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' incluído com sucesso!', color: 'success', dialog: true})
              },
              err => {
                console.log(err)
                this.loadingAddField = false
                this.$store.commit('snackbar/change_values', { text: 'Não foi possível incluir o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true })
              })
          }
        } else if (this.view >= 3) {
          // se a tarefa ou tarefa modelo for inclusão então não usa o banco, pois isso é feito no fim do processo
          if (this.originView === 2) {
            this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/edit_value`, this.editedItem)
            this.closeCustomField()
          } else {
            this.$http.put('api/' + this.entity + '/' + this.editedItem.id, this.editedItem).then(
              (res) => {
                this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/edit_value`, res.body)
                // ---- Inicio Socket----
                // adiciona na tarefa e na tarefa modelo
                this.$socket.emit('generalEvent', {
                  data: res.body,
                  responseEvent: 'editSocketCustomField',
                  room: `tasktemplates_cf_${this.tasktemplate_id}`
                })
                // ---- Fim Socket----
                this.closeCustomField()
                this.$store.commit('snackbar/change_values', { text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' editado com sucesso!', color: 'success', dialog: true })
              },
              err => {
                console.log(err)
                this.loadingAddField = false
                this.$store.commit('snackbar/change_values', { text: 'Não foi possível editar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true })
              }
            )
          }
        }
      },
      closeCustomField () {
        this.view = 1
        this.showAddField = false
        this.loadingAddField = false
        // Ao receber o default fechar o campo que estão aberto
        Object.assign(this.fieldEditing, this.defaultFieldEditing)
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
      },
      createField () {
        console.log('createField')
      },
      openDialog () {
        this.dialogFieldEditable = true
      },
      dialogDelete (field) {
        this.dialogConfirm = true
        this.closeLastOption()
        // Joga o defaultFieldEditing para fechar alguma edição que esteja aberta
        Object.assign(this.fieldEditing, this.defaultFieldEditing)
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        Object.assign(this.editedItem, field)
      },
      closeDialogDelete () {
        this.dialogConfirm = false
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
      },
      deleteItem () {
        // se a tarefa ou tarefa modelo for inclusão então não usa o banco, pois isso é feito no fim do processo
        if (this.originView === 2) {
          this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/delete_value`, this.editedItem['id'])
          this.closeDialogDelete()
          this.closeCustomField()
        } else {
          this.$store.commit('loader/change_dialog', true)
          this.$http.delete(`api/${this.entity}/${this.editedItem.id}`).then(
            (res) => {
              let customFieldId = res.body['id']
              this.closeDialogDelete()
              this.closeCustomField()
              this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/delete_value`, customFieldId)
              // ---- Inicio Socket----
              // adiciona na tarefa e na tarefa modelo
              this.$socket.emit('generalEvent', {
                data: customFieldId,
                responseEvent: 'deleteSocketCustomField',
                room: `tasktemplates_cf_${this.tasktemplate_id}`
              })
              // ---- Fim Socket----
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', { text: 'Registro de campo personalizado excluído com sucesso!', color: 'success', dialog: true })
            },
            err => {
              console.log(err)
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', { text: 'Não foi possível deletar o registro campo personalizado, o erro.', color: 'error', dialog: true })
            })
        }
      },
      closeLastOption () {
        // Caso tenha um expanded true no item anterior, então fecha
        let item = this.customFields.find((val) => { return val.id === this.lastFieldOptionOpenId })
        if (item && item['expanded']) {
          item['expanded_transaction'] = false
          setTimeout(() => { item['expanded'] = false }, 100)
          // this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/edit_value`, item)
        }
      },
      getFieldIcon (type) {
        let result = ''
        switch (type) {
          case 'number':
            result = 'pin'
            break
          case 'value':
            result = 'attach_money'
            break
          case 'string':
            result = 'notes'
            break
          case 'select':
            result = 'check_box'
            break
          case 'multiselect':
            result = 'library_add_check'
            break
          case 'date':
            result = 'calendar_today'
            break
          case 'datetime':
            result = 'schedule'
            break
          case 'files':
            result = 'file_present'
            break
          case 'phone':
            result = 'phone'
            break
          case 'email':
            result = 'email'
            break
        }
        return result
      }
    },
    computed: {
      customFields () {
        return this.$store.state[`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}`].values
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/shared/PCustomFieldEditable.vue